import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ManageAdmin from "../components/ManageAdmin";

const ManageAdminPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title='Manage Admin' />

        <ManageAdmin />

      </MasterLayout>
      
    </>
  );
};

export default ManageAdminPage;
